import * as StyleFunctions from '../utilities/StyleFunctions';
import React, {useRef, useEffect} from 'react';
import hourglass from '../images/hourglass.png' ;

function App(props) {

  var thisItem = props.thisItem;
  var itemInfoPath = props.itemInfoPath;
  var currentList = props.currentList;
  var internalVariables = props.internalVariables;
  var width = props.width;
  var height = props.height;
  var upwardInfo = props.upwardInfo;
  var inputValues = props.inputValues;
  var ownVariables = props.ownVariables;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var allStyles = props.allStyles;
  var stylesToAdd = props.stylesToAdd;
  var interactionFn = props.interactionFn;
  var clickFn = props.clickFn;
  var popUps = props.popUps;
  var setPopUps = props.setPopUps;
  var actHoveringWhere = props.actHoveringWhere;
  var addClassNames = props.addClassNames;
  var addCCColWidth = props.addCCColWidth;
  var draggable = props.draggable;
  var onDragStart = props.onDragStart;
  var onDragEnd = props.onDragEnd;
  var onDrag = props.onDrag;
  var itemInfoPathString = props.itemInfoPathString;
  var doAScreenRef = props.doAScreenRef;
  var chains = props.chains;

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, itemInfoPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

     var imageStyles = StyleFunctions.evaluateStyleR('GALLERYGENERALIMAGE', thisItem.s, itemInfoPath.concat(['s']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
      var colW = allStyles.colWidthInternal;
      var galleryClassNames = StyleFunctions.iterateClassNames('col-' + colW, ['galleryHover', 'textAlignment'], allStyles);

    var cc3 = {...stylesToAdd, ...allStyles};

    var srcList = [];
    if (allStyles.srcList){
      srcList = allStyles.srcList;
    }

    var capList = [];
    if (!allStyles.hideCaption){
      capList = allStyles.capList;
    }
    var galleryItems = null;
    try{
      galleryItems = srcList.map((aURL, index)=>{
        if (interactionFn){
          clickFn = function(e){
            popUps.push({t:'popUp',srcList, item:+index, mvtIcon:allStyles.mvtIcon, buttonsOutside:allStyles.buttonsOutside});
            setPopUps([...popUps]);
            e.stopPropagation();
          }
        }

        var caption = null;
        if (capList.length > +index){
           var stylesToAddText = StyleFunctions.evaluateStyleR('GALLERYGENERAL', thisItem.s, itemInfoPath.concat(['s']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
          StyleFunctions.expandBIU(stylesToAddText);
          caption = <figcaption style={stylesToAddText}>{capList[+index]}</figcaption>;
        }
    //    
        var gridOverlay = null;
        if (galleryClassNames.indexOf('galleryHover4') > -1){
           gridOverlay = <div className='gridOverlay' style={{width:'100%', height:'100%', }}>
                                            <button style = {{background: 'none', outline: 'none', fontWeight: '100', border: '1px solid white', color: 'white', padding: '10px'}}>View More</button>
                                        </div>
        }

        if (aURL === '-' || aURL === ''){
          aURL = hourglass;
        }

        if (aURL.indexOf('ipfs://') === 0){
          aURL = 'https://ipfs.io/ipfs/' + aURL.substr(7);
        }

    //    {maxWidth:'100%', maxHeight:'100%', border: '1px solid black', backgroundColor: 'green'}
       return (<div className={galleryClassNames} style={stylesToAdd} onClick={clickFn} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')}>
                  <img className = '' style={imageStyles} src={aURL} alt='Gallery' />
                  {caption}
                  {gridOverlay}
               </div>)
    //
      })
    }catch(err){

    }


    var className31 = StyleFunctions.iterateClassNames('container-fluid' + addClassNames  , [], allStyles);
    if (srcList.length === 0 && !interactionFn){
      galleryItems = <div className='col-12'>[Empty Gallery. This message only appears in design mode]</div>
    }
//
    var insGallery = <div className={className31} style={cc3}><div className='row'>{galleryItems}</div></div>

    return <div ref={ref1} className={addCCColWidth} onClick={clickFn} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')}>{insGallery}</div>
    
}
//




export default App;
